<template>
  <div class="body">
    <fwaltop></fwaltop>
    <div class="fwal">
      <div class="fwalicons">
        <div class="icon icons" @mouseenter="x1" @mouseleave="y" @click="ServiceCase">
          <div class="flex">
            <img
              v-if="l1 == true"
              class="fleximg"
              src="./../assets/官网切图2.0/官网切图2.0/解决方案_BMS_绿.svg"
              alt=""
            />
            <img
              v-else
              class="fleximg"
              src="./../assets/官网切图2.0/官网切图2.0/解决方案_BMS_灰.svg"
              alt=""
            />
            <div>智控系统集成</div>
          </div>
          <img
            v-if="l1 == true"
            class="jt"
            src="./../assets/520/方向.svg"
            alt=""
          />
        </div>
        <div class="icon icons" @mouseenter="x2" @mouseleave="y" @click="ServiceSoftware">
          <div class="flex">
            <img
              v-if="l2 == true"
              class="fleximg"
              src="./../assets/官网切图0430/官网切图0430/解决方案_定制_绿.svg"
              alt=""
            />
            <img
              v-else
              class="fleximg"
              src="./../assets/官网切图0430/官网切图0430/解决方案_定制_灰.svg"
              alt=""
            />
            <div>软件平台产品</div>
          </div>
          <img
            v-if="l2 == true"
            class="jt"
            src="./../assets/520/方向.svg"
            alt=""
          />
        </div>
        <div class="icon icons" @mouseenter="x3" @mouseleave="y" @click="ServiceSystem">
          <div class="flex">
            <img
            v-if="l3 == true"
              class="fleximg"
              src="./../assets/官网切图2.0/官网切图2.0/解决方案_节能_绿.svg"
              alt=""
            />
             <img
             v-else
              class="fleximg"
              src="./../assets/官网切图2.0/官网切图2.0/解决方案_节能_灰.svg"
              alt=""
            />
            <div>系统节能改造</div>
          </div>
          <img
            v-if="l3 == true"
            class="jt"
            src="./../assets/520/方向.svg"
            alt=""
          />
        </div>
        <div class="icon changecolor">
          <div class="flex">
            <img
              class="fleximg"
              src="./../assets/官网补充切图2/官网补充切图/服务案例_动力_白2.svg"
              alt=""
            />
            <div class="xiticolor">能源系统集成</div>
          </div>
          <img
            class="jt"
            src="./../assets/官网补充切图2/官网补充切图/箭头.svg"
            alt=""
          />
        </div>
      </div>
      <div class="three">
        <img
          src="./../assets/官网补充/官网补充/img_案例11.png"
          alt=""
          class="tworight"
        />
        <div class="twoleft">
          <div class="twoleftfirstdiv">
            <div class="divfirst"></div>
            <div class="title">老港垃圾焚烧热回收系统</div>
            <!-- <div class="time">2021年12月12日</div> -->
          </div>
          <div class="twoleftseconddiv">
            老港垃圾焚烧基地存在着大量的焚烧余热，本项目设计建造了一套余热利用机电及监控系统用于花园热带植物的种植。热带植物花园位于室外，风速较高，我司设计人员利用FLUNT模拟软件模拟了整个室外的气流及温度场，通过敷设热管位置的不同与多少，利用焚烧产生的蒸汽热交换产生的热水用于花园的热量辐射。
          </div>
        </div>
      </div>
      <div class="two">
        <div class="twoleft">
          <div class="twoleftfirstdiv">
            <div class="divfirst"></div>
            <div class="title">临港密博汽车工艺冷却水系统</div>
            <!-- <div class="time">2021年12月12日</div> -->
          </div>
          <div class="twoleftseconddiv">
            作为宝马汽车喷油嘴专业供应商，密博汽车位于临港制造园区新建厂房需求工艺冷却水系统。我司作为设计单位，帮助密博汽车设计建造了一套工艺冷却系统。该系统采用了风冷热泵系统，通过控制系统安全稳定的对末端设备进行工艺供冷。
          </div>
        </div>
        <img
          src="./../assets/服务案例01/服务案例03.png"
          alt=""
          class="tworight"
        />
      </div>
      <div class="three">
        <img
          src="./../assets/服务案例01/服务案例05.png"
          alt=""
          class="tworight"
        />
        <div class="twoleft">
          <div class="twoleftfirstdiv">
            <div class="divfirst"></div>
            <div class="title">东风本田工厂机电改造</div>
            <!-- <div class="time">2021年12月12日</div> -->
          </div>
          <div class="twoleftseconddiv">
            我司承建的东本工厂能源计量机电改造系统顺利通过验收。本项目针对工厂内统计的所有流量计、能量计、天然气表具等实施改造、更换，并在原设计方案进行了二次优化，达到改造目的。
          </div>
        </div>
      </div>
      <div class="more">- 更多案例请咨询 -</div>
    </div>
    <under></under>
  </div>
</template>

<script>
import under from "../components/under.vue";
import fwaltop from "../components/fwaltop.vue";
export default {
  components: { under, fwaltop },
  data: function () {
    return { l1: false, l2: false, l3: false };
  },
  created() {},
  methods: {
    xq1() {
      this.$router.push("/fwalxq");
    },
    ServiceCase() {
      this.$router.push("/ServiceCase");
    },
    ServiceSoftware() {
      this.$router.push("/ServiceSoftware");
    },
    ServiceSystem() {
      this.$router.push("/ServiceSystem");
    },
    x1() {
      this.l1 = true;
      this.l2 = false;
      this.l3 = false;
    },
    x2() {
      this.l1 = false;
      this.l2 = true;
      this.l3 = false;
    },
    x3() {
      this.l1 = false;
      this.l2 = false;
      this.l3 = true;
    },
    y() {
      this.l1 = false;
      this.l2 = false;
      this.l3 = false;
    },
  },
};
</script>

<style lang="less" scoped>
.body {
  width: 100%;

  .fwal {
    width: 100vw;
    .fwalicons {
      width: 66vw;
      margin-left: 17vw;
      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-top: 5vh;
      margin-bottom: 5vh;
      .icon {
        width: 14.5vw;
        cursor: pointer;
        .flex {
          width: 14.5vw;
          display: flex;
          .fleximg {
            margin-top: 3vh;
            margin-bottom: 3vh;
            width: 2vw;
            margin-left: 2vw;
          }
          div {
            margin-top: 3vh;
            margin-left: 1vw;
            color: rgba(51, 51, 51, 1);
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 1vw;
            line-height: 2vw;
          }
          .xiticolor {
            color: rgba(255, 255, 255, 1);
          }
        }
        .jt {
          margin-bottom: 3vh;
          width: 2vw;
        }
      }
      .icons:hover {
        border-radius: 6px;
        .flex {
          div {
            color: #3dae6d;
          }
        }
      }
      .changecolor {
        border-radius: 6px;
        background: rgba(61, 174, 109, 1);
      }
    }
    .two {
      width: 66.7vw;
      margin-left: 16.65vw;
      display: flex;
      justify-content: space-around;
      margin-top: 12vh;
      margin-bottom: 5vh;
      text-align: justify;
      .twoleft {
        width: 27vw;

        .twoleftfirstdiv {
          display: flex;
          height: 5vh;
          margin-top: 3vh;
          .divfirst {
            margin-top: 1.45vh;
            margin-left: 2.5vw;
            width: 0.7vh;
            height: 2.1vh;
            border-radius: 6px;
            background: rgba(61, 174, 109, 1);
          }
          .title {
            margin-left: 0.5vw;
            line-height: 5vh;
            margin-bottom: 2vh;
            color: rgba(51, 51, 51, 1);
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 2.5vh;
          }
        }
        .twoleftseconddiv {
          width: 25vw;
          margin-left: 1vw;
          margin-top: 5vh;
          color: rgba(102, 102, 102, 1);
          font-family: Microsoft YaHei;
          font-size: 1.6vh;
          line-height: 200%;
        }
      }
      .tworight {
        width: 37.7vw;
      }
    }
    .three {
      width: 66.7vw;
      margin-left: 16.65vw;
      display: flex;
      justify-content: space-around;
      margin-top: 12vh;
      margin-bottom: 5vh;
      text-align: justify;
      .twoleft {
        width: 27vw;

        .twoleftfirstdiv {
          display: flex;
          height: 5vh;
          margin-top: 3vh;
          .divfirst {
            margin-top: 1.45vh;
            margin-left: 2.5vw;
            width: 0.7vh;
            height: 2.1vh;
            border-radius: 6px;
            background: rgba(61, 174, 109, 1);
          }
          .title {
            // width: 15vw;
            margin-left: 0.5vw;
            line-height: 5vh;
            margin-bottom: 2vh;
            color: rgba(51, 51, 51, 1);
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 2.5vh;
          }
        }
        .twoleftseconddiv {
          width: 25vw;
          margin-left: 1vw;
          margin-top: 5vh;
          color: rgba(102, 102, 102, 1);
          font-family: Microsoft YaHei;
          font-size: 1.6vh;
          line-height: 200%;
        }
      }
      .tworight {
        width: 37.7vw;
      }
    }
    .more {
      margin-left: 44vw;
      width: 12vw;
      height: 5vh;
      line-height: 5vh;
      border-radius: 6px;
      font-size: 1vw;
      text-align: center;
      border: 1px solid rgba(61, 174, 109, 1);
      color: rgb(61, 174, 109);
      margin-top: 10vh;
      margin-bottom: 10vh;
    }
  }
}
</style>
